import React, { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { Header } from './header-landing-page';
import colors from '@packages/core/styles/colors';

const useSiteLinkLayoutStyles = createUseStyles({
    layout: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    },
    content: {
        flex: 1,
        width: '100%',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '56px 20px',
        background: '#F8F8F8',
    },
    card: {
        maxWidth: '1440px',
        width: '100%',
        background: colors.white,
        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.16)',
    },
});

interface SiteLinkLayoutProps {
    children: ReactNode;
}

export const SiteLinkLayout: FC<SiteLinkLayoutProps> = ({ children }) => {
    const classes = useSiteLinkLayoutStyles();

    return (
        <div className={classes.layout}>
            <Header />
            <div className={classes.content}>
                <div className={classes.card}>{children}</div>
            </div>
        </div>
    );
};
